import { render, staticRenderFns } from "./TemplateActionDelete.vue?vue&type=template&id=d8bbabaa&"
import script from "./TemplateActionDelete.vue?vue&type=script&lang=ts&"
export * from "./TemplateActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports